import React from "react";
import ReactDOM from "react-dom/client";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

// admin_lte

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/Authcontext";
// import { Home } from './views/home';
import Dashboard from "./views/admin/Dashboard";

// Make jQuery globally available
import $ from "jquery";
import AdminSettings from "./views/admin/components/AdminSettings";
import AdminRoles from "./views/admin/components/AdminRoles";
import AdminAddRoles from "./views/admin/components/AdminAddRoles";
import ProtectedRoute from "./views/admin/ProtectedRoute";
import AdminLogin from "./views/admin/AdminLogin";
import BrowseRecharge from "./views/admin/components/BrowseRecharge";
import { Toaster } from "react-hot-toast";
import Profile from "./views/admin/components/Profile";
import { AdminNotificationProvider } from "./context/AdminNotificationContext";
import urlBase64ToUint8Array from "./utility/urlBase64ToUint8Array";
import { HelmetProvider } from 'react-helmet-async';
import AdminLayout from "./views/admin/components/AdminLayout";
import DepositHistory from "./views/admin/components/DepositHistory";
import AgentWhitelist from "./views/admin/components/AgentWhitelist";
import CustomerWhitelist from "./views/admin/components/CustomerWhitelist";
import CasinoReport from "./views/admin/components/CasinoReport";
import ClientWallet from "./views/admin/components/ClientWallet";
import Company from "./views/admin/components/Company";
import AdminRecharge from "./views/admin/components/AdminRecharge";
import ChipsReport from "./views/admin/components/ChipsReport";
import AccountStatement from "./views/admin/components/AccountStatement";
import AdminChips from "./views/admin/components/AdminChips";
import GgrReport from "./views/admin/components/GgrReport";
import Currency from "./views/admin/components/Currency";
import DeleteCustomers from "./views/admin/components/DeleteCustomers";
import CustomerDepositHistory from "./views/admin/components/CustomerDepositHistory";
import CasinoHistory from "./views/admin/components/Turnkeyhistory";


window.jQuery = $;
window.$ = $;

function registerServiceWorkerAndSubscribe() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // console.log("Service Worker registered:", registration);

        return registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            process.env.REACT_APP_VAPID_PUBLIC_KEY
          ),
        });
      })
      .then((subscription) => {
        // console.log("Push subscribed:", subscription);

        // this part of code send notification only admin 
        
        const payload = {
          ...subscription.toJSON(),
          role: "admin", // Or "user", etc.
          userId: "9588405", // Dynamically get this from user context if needed
          active: true,
        };
        /************/  

        // console.log("Subscription payload to send:", payload);

        return fetch("http://localhost:3004/subscribe", {
          method: "POST",
          body: JSON.stringify(payload),
          // body: JSON.stringify(subscription.toJSON()),
          headers: {
            "Content-Type": "application/json",
          },
        });
      })
      .then((res) => res.json())
      .then((data) => {
        console.log("Server response:", data);
      })
      .catch((error) => {
        console.error("Push notification error:", error);
      });
  }
}

function askNotificationPermissionAndSubscribe() {
  if (!("Notification" in window)) {
    console.warn("This browser does not support notifications.");
    return;
  }

  if (Notification.permission === "granted") {
    registerServiceWorkerAndSubscribe();
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        registerServiceWorkerAndSubscribe();
      } else {
        console.warn("Notification permission denied by the user.");
      }
    });
  } else {
    console.warn("Notification permission was previously denied.");
  }
}


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
  <Router>
    <AuthProvider>
      <Toaster position="top-right" reverseOrder={false} />
      <AdminNotificationProvider>
        <Routes>
          {/* Admin Routes */}
          <Route path="/" element={<AdminLogin />} />
          <Route element={<ProtectedRoute />}>

         <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/browse_recharge" element={<BrowseRecharge />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/roles" element={<AdminRoles />} />
            <Route path="/admin/deposit_history" element={<DepositHistory />} />
            <Route path="/admin/customer/deposit_history" element={<CustomerDepositHistory />} />
            <Route path="/admin/add_roles" element={<AdminAddRoles />} />
            <Route path="/admin/Profile" element={<Profile />} />
            <Route path="/admin/agentWhitelist" element={<AgentWhitelist />} />
            <Route path="/admin/customerWhitelist" element={<CustomerWhitelist />} />
            <Route path="/admin/casinoReport" element={<CasinoReport />} />
            <Route path="/admin/clientWallet" element={<ClientWallet />} />
            <Route path="/admin/company" element={<Company />} />
            <Route path="/admin/adminRecharge" element={<AdminRecharge />} />
            <Route path="/admin/chipsReport" element={<ChipsReport />} />
            <Route path="/admin/account" element={<AccountStatement />} />
            <Route path="/admin/adminchipsReport" element={<AdminChips />} />
            <Route path="/admin/ggrReport" element={<GgrReport />} />
             <Route path="/admin/currency" element={<Currency />} />
             <Route path="/admin/DeleteCustomers" element={<DeleteCustomers />} />
              <Route path="/admin/turnkeyHistory" element={<CasinoHistory />} />
            </Route>
          </Route>
        </Routes>
      </AdminNotificationProvider>
    </AuthProvider>
  </Router>
  </HelmetProvider>
);

askNotificationPermissionAndSubscribe();
reportWebVitals();
